export const discountTypes = Object.freeze({
    MULTIPLIER: 1,
    FIXED: 2,
});
